import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Cog = ({
  className,
  color = '#fff',
  width = 24,
  height = 24
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M9.88259 4.5c0-.27614.23281-.5.52011-.5h3.1206c.2872 0 .5201.22386.5201.5v1.84141c.6951.23621 1.3338.58746 1.8911 1.02996l1.6161-.97079c.2436-.14633.5644-.07511.7166.15907l1.6537 2.54414c.1522.23418.0781.54265-.1655.68899l-1.6761 1.00692c.0819.3878.1249.7892.1249 1.2003 0 .4472-.0509.883-.1475 1.3023l1.6248.976c.2436.1464.3177.4548.1655.689l-1.6537 2.5441c-.1522.2342-.4731.3054-.7167.1591l-1.6257-.9766c-.5373.4118-1.1469.7402-1.8075.9647V19.5c0 .2761-.2329.5-.5201.5h-3.1206c-.2873 0-.52011-.2239-.52011-.5v-1.8414c-.6259-.2127-1.20598-.5186-1.72217-.9004l-1.63704.9834c-.24359.1463-.56446.0751-.71667-.1591l-1.65367-2.5441c-.15221-.2342-.07813-.5427.16546-.689l1.57492-.9461c-.1122-.4502-.17162-.9201-.17162-1.4033 0-.4472.05089-.883.14742-1.3023l-1.62466-.97598c-.2436-.14633-.31768-.4548-.16546-.68898l1.65366-2.54415c.15222-.23418.47308-.30539.71668-.15906l1.62565.97656c.53729-.41184 1.14687-.7402 1.8075-.96468V4.5ZM11.963 15c1.7234 0 3.1206-1.3431 3.1206-3s-1.3972-3-3.1206-3c-1.7235 0-3.12061 1.3431-3.12061 3s1.39711 3 3.12061 3Z" 
        fill={color}
      />
    </svg>
  );
};
